import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-saga/root-state';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.login || initialState;

export const selectAuthLoading = createSelector(
  [selectSlice],
  (state) => state.loading,
);

export const selectAuthError = createSelector(
  [selectSlice],
  (state) => state.error,
);
